import { Injectable } from '@angular/core';
import {
    ConfirmDialogComponent,
    ConfirmDialogData,
    ConfirmDialogResult,
} from '../components/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserReadableError } from '../../app/api/errors/user-readable.error';
import { Observable } from 'rxjs';
import { TcDialogComponent } from '../../app/modules/auth/components/tc-dialog/tc-dialog.component';

export interface ConfirmDialogCallbacks {
    primaryCallback?: () => void;
    primaryCallbackWithId?: (id: string) => void;
    secondaryCallback?: () => void;
    cancelCallback?: () => void;
    errorCallback?: (error: UserReadableError) => void;
}

@Injectable({
    providedIn: 'root',
})
export class ConfirmDialogService {
    public disableClose: boolean;

    constructor(private dialog: MatDialog) {}

    public get DisableDialogClose(): boolean {
        return this.disableClose;
    }

    public static getConfirmSubmitDialogData(
        title: string,
        description: string,
        submitAction: () => Observable<any> | void,
        optional_description = '',
    ): ConfirmDialogData {
        return {
            title: title,
            description: description,
            optional_description: optional_description,
            hasNote: false,
            primaryButton: {
                text: $localize`Confirm`,
                action: submitAction,
            },
            cancelButton: { text: $localize`Cancel` },
        };
    }

    public static getConfirmCvrSubmitDialogData(
        title: string,
        description: string,
        submitAction: () => void,
        hasNote = false,
    ): ConfirmDialogData {
        return {
            title: title,
            description: description,
            hasNote: hasNote,
            primaryButton: {
                text: $localize`Yes`,
                action: submitAction,
            },
            cancelButton: { text: $localize`Cancel` },
        };
    }

    public static getDialogDataWithSecondaryButton(
        title: string,
        description: string,
        submitAction: () => Observable<any> | void,
        optional_description = '',
        primaryButtonText = $localize`Accept`,
        secondaryButtonText = $localize`Decline`,
        secondDescription?: string,
    ): ConfirmDialogData {
        return {
            title: title,
            description: description,
            optional_description: optional_description,
            hasNote: false,
            second_description: secondDescription,
            primaryButton: {
                text: primaryButtonText,
                action: submitAction,
            },
            secondaryButton: {
                text: secondaryButtonText,
                action: submitAction,
            },
        };
    }

    public showDialog(config: ConfirmDialogData, callbacks: ConfirmDialogCallbacks, disableClose = false, isTC?: boolean): void {
        this.disableClose = disableClose;

        let dialogRef;
        if (isTC) {
            dialogRef = this.dialog.open(TcDialogComponent, {
                width: '535px',
                data: {
                    ...config,
                    disableDialogClose: this.DisableDialogClose,
                },
                disableClose: disableClose,
            });
        } else {
            dialogRef = this.dialog.open(ConfirmDialogComponent, {
                data: {
                    ...config,
                    disableDialogClose: this.DisableDialogClose,
                },
                disableClose: disableClose,
            });
        }

        if (!callbacks) {
            return;
        }

        dialogRef.afterClosed().subscribe((dialogResult: ConfirmDialogResult) => {
            if (dialogResult) {
                if (dialogResult.chosePrimary && callbacks.primaryCallback) {
                    callbacks.primaryCallback();
                }

                if (dialogResult.choseSecondary && callbacks.secondaryCallback) {
                    callbacks.secondaryCallback();
                }

                if (dialogResult.choseCancel && callbacks.cancelCallback) {
                    callbacks.cancelCallback();
                }

                if (dialogResult.error && callbacks.errorCallback) {
                    callbacks.errorCallback(dialogResult.error);
                }
            }
        });
    }
}
